import React from 'react';
import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import {usePostApi} from 'common/hooks/usePostApi';
import {castToSend} from 'common/yup/castToSend';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {IIPAccessRulesSettings} from 'types/diplomat/sftp/IPAccessRulesSettings';
import {ISftpServerSettings, SftpServerSettings} from 'types/diplomat/sftp/SftpServerSettings';
import IPAccessRulesDialog from './IPAccessRulesDialog';
import {useTranslation} from 'react-i18next';
import {useToasts} from 'features/notifications/useToasts';

export const SftpIPAccessRulesDialog = ({onClose}: {onClose: () => void}) => {
   const {t} = useTranslation();

   const {addToast} = useToasts();
   const {state: settings, request, loading} = useGetApi<ISftpServerSettings>(
      api.sftpServerSettings
   );
   React.useEffect(() => {
      request();
   }, [request]);

   const {request: saveSettings} = usePostApi(`${api.sftpServerSettings}?noWarning=true`);
   const onSubmit = React.useCallback(
      (values?: IIPAccessRulesSettings, helpers?: FormOnSubmitHelpers<IIPAccessRulesSettings>) => {
         if (!values) {
            onClose();
            return;
         }

         const data = castToSend(SftpServerSettings, {...settings, accessRule: values});
         saveSettings(JSON.stringify(data), {
            onSuccess: (data) => {
               helpers?.setSubmitting(false);
               addToast(t('IP Access Rules Saved'), {
                  appearance: 'success',
               });
               onClose();
            },
            onFailure: (err) => {
               helpers?.setErrors(err);
               helpers?.setSubmitting(false);
            },
         });
      },
      [saveSettings, onClose, settings]
   );

   return <IPAccessRulesDialog onClose={onSubmit} data={{values: settings?.accessRule}} />;
};
